import React from 'react';
import I18n from 'i18n-js';

import RecentArticles from './recent_articles';
import HomepageCategories from '../homepage_categories';
import HomepageSell from './homepage_sell';
import HomepageNewsletter from './homepage_newsletter';
import HomepageDealsAndStealsListingsCollection from '../../homepage_deals_and_steals_listings_collection';
import LoggedOutRecommendationsRow from '../../recommended_listings/logged_out_recommendations_row';
import HomepageTrendingSearches from './homepage_trending_searches';
import HomePageSellVisibilityV2 from './homepage_sell_visibility_v2';

import CmsListingsCollection from '@reverbdotcom/commons/src/cms/components/cms_listings_collection';
import CmsEmbed from '@reverbdotcom/commons/src/components/cms_embed';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';

export function LoggedOutHomepage() {
  const user = useUser();

  return (
    <>
      <div className="mb-gap-row">
        <CmsEmbed slug="logged-out-homepage" ssrMode="full" />
      </div>
      <div>
        <LoggedOutRecommendationsRow />
        <HomePageSellVisibilityV2 />
        <HomepageTrendingSearches />
        <CmsEmbed slug="homepage-embed" ssrMode="static-only" />
        <HomepageCategories
          title={I18n.t('discovery.homepage.loggedOutNew.shopByInstrument')}
        />
        <RecentArticles
          title={I18n.t('discovery.homepage.loggedOutNew.explore')}
        />
        <HomepageNewsletter signupReason="loggedouthomepage" />
        <CmsListingsCollection
          ctaTargetHref="/marketplace?condition=used"
          conditionSlugs={['used']}
          userShippingRegion={user.shippingRegionCode}
          componentName="HomepageLatestListings"
          maxCount={12}
          largeTiles
          ssr={false}
          title={I18n.t('discovery.homepage.loggedOutNew.latestGear')}
        />
        <HomepageDealsAndStealsListingsCollection
          title={I18n.t('discovery.homepage.loggedOutNew.dealsAndSteals')}
        />
        <HomepageSell />
      </div>
    </>
  );
}

export default LoggedOutHomepage;
